import { render, staticRenderFns } from "./InspectionPage.vue?vue&type=template&id=493366fc&"
import script from "./InspectionPage.vue?vue&type=script&lang=ts&"
export * from "./InspectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports